import { getFocusabledIn as d } from "focus-lock";
import l from "../../../utils/directives/click-outside.js";
import { resolveDirective as f, withDirectives as a, createElementBlock as h, openBlock as m, withKeys as r, withModifiers as c, renderSlot as p } from "vue";
import x from "../../../_virtual/_plugin-vue_export-helper.js";
const I = {
  name: "DsSelectBoxContainer",
  directives: { clickOutsideAwds: l },
  props: {
    firstLetterSearch: {
      type: Boolean,
      default: !0
    }
  },
  data: () => ({
    opened: !1,
    focusableElements: [],
    focusIndex: 0,
    maxTopIndex: 0
  }),
  mounted() {
    var s, e;
    if (this.$el) {
      this.focusableElements = d(this.$el) || [];
      const t = ((e = (s = this.focusableElements) == null ? void 0 : s[0]) == null ? void 0 : e.node) || null;
      this.maxTopIndex = (t == null ? void 0 : t.nodeName) === "BUTTON" ? 1 : 0;
    }
  },
  methods: {
    handleClickOutside() {
      this.close(), this.$emit("click-outside");
    },
    open() {
      this.opened = !0;
    },
    close(s) {
      this.opened && (this.opened = !1, this.resetFocusIndex(), (s == null ? void 0 : s.code) === "Escape" && setTimeout(() => {
        this.focusOnFirstElement();
      }, 10));
    },
    focus() {
      this.resetFocusIndex(), this.opened && this.focusOnFirstElement();
    },
    resetFocusIndex() {
      this.focusIndex = 0;
    },
    focusOnFirstElement() {
      var e, t;
      const s = (t = (e = this.focusableElements) == null ? void 0 : e[0]) == null ? void 0 : t.node;
      s.focus(), this.resetFocusIndex(), s.nodeName === "INPUT" && setTimeout(() => {
        s.selectionStart = s.selectionEnd = s.value.length;
      }, 0);
    },
    handleKeypress(s) {
      if (!this.opened || !this.firstLetterSearch)
        return;
      const e = d(this.$el).find((t) => {
        var i;
        return ((i = t == null ? void 0 : t.node) == null ? void 0 : i.innerText.charAt(0).toLowerCase()) === s.key;
      });
      e && (this.focusIndex = e == null ? void 0 : e.index, e == null || e.node.focus());
    },
    handleArrowNavigation(s) {
      const e = s === "up" ? -1 : 1;
      if (this.focusableElements = d(this.$el), this.focusIndex = this.focusIndex + e, this.focusIndex < this.maxTopIndex && e === -1) {
        this.focusIndex = this.maxTopIndex;
        return;
      }
      if (this.focusIndex === this.focusableElements.length) {
        this.focusIndex = this.focusIndex - 1;
        return;
      }
      this.focusableElements[this.focusIndex].node.focus();
    }
  }
};
function w(s, e, t, i, E, o) {
  const u = f("click-outside-awds");
  return a((m(), h("div", {
    class: "ds-position-relative",
    onKeydown: [
      e[0] || (e[0] = r(c((...n) => o.close && o.close(...n), ["stop"]), ["escape"])),
      e[2] || (e[2] = r(c((n) => o.handleArrowNavigation("up"), ["prevent"]), ["up"])),
      e[3] || (e[3] = r(c((n) => o.handleArrowNavigation("down"), ["prevent"]), ["down"]))
    ],
    onKeypress: e[1] || (e[1] = (...n) => o.handleKeypress && o.handleKeypress(...n))
  }, [
    p(s.$slots, "default", {
      opened: s.opened,
      focusIndex: s.focusIndex,
      focus: o.focus,
      close: o.close,
      open: o.open
    })
  ], 32)), [
    [u, o.handleClickOutside]
  ]);
}
const y = /* @__PURE__ */ x(I, [["render", w]]);
export {
  y as default
};
